import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=3d90b558&scoped=true&"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecovery.vue?vue&type=style&index=0&id=3d90b558&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90b558",
  null
  
)

export default component.exports